import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { GaugeSimulationProvider } from "./context/GaugeSimulationContext";
import { ConfirmProvider } from "./context/ConfirmContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Companies from "./pages/Companies";
import Devices from "./pages/Devices";
import DeviceDetail from "./pages/DeviceDetail";
import DataLoggerDetail from "./pages/DataLoggerDetail";
import InverterDetail from "./pages/InverterDetail";
import DetailedParameters from "./pages/DetailedParameters";
import EnergyMeterDetail from "./pages/EnergyMeterDetail";
import EnergyMeterDetailChint from "./pages/EnergyMeterDetailChint";
import Alarms from "./pages/Alarms";
import Reports from "./pages/Reports";
import ProductionPlanning from "./pages/ProductionPlanning";
import Control from "./pages/Control";
import Analysis from "./pages/Analysis";
import Kosova from "./pages/Kosova";
import MePage from "./pages/MePage";
import PvFleetEnergyDashboard from "./pages/PvFleetEnergyDashboard";
import { SystemSettingsPage, AboutPage } from "./pages/AccountMobilePages";
import { ConnectionsPage } from "./pages/ConnectionsPage";
import "./App.css";
import "./styles/Login.css";

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <ConfirmProvider>
          <BrowserRouter>
            <GaugeSimulationProvider>
              <Toaster
                position="top-center"
                richColors
                closeButton
                theme="dark"
              />
              <Routes>
                <Route path="/login" element={<Login />} />

                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/analysis"
                  element={
                    <ProtectedRoute>
                      <Analysis />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/production-planning"
                  element={
                    <ProtectedRoute requiredRoles={["SUPERADMIN", "ADMIN"]}>
                      <ProductionPlanning />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/control"
                  element={
                    <ProtectedRoute requiredRoles={["SUPERADMIN", "ADMIN"]}>
                      <Control />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/users"
                  element={
                    <ProtectedRoute requiredRoles={["SUPERADMIN", "ADMIN"]}>
                      <Users />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/companies"
                  element={
                    <ProtectedRoute requiredRoles={["SUPERADMIN"]}>
                      <Companies />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/devices"
                  element={
                    <ProtectedRoute>
                      <Devices />
                    </ProtectedRoute>
                  }
                />

                {/* Redirect old DeviceDetail route to new DataLoggerDetail */}
                <Route
                  path="/devices/:id"
                  element={
                    <ProtectedRoute>
                      <DataLoggerDetail />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/devices/:id/inverter/:inverterId"
                  element={
                    <ProtectedRoute>
                      <InverterDetail />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/devices/:id/inverter/:inverterId/parameters"
                  element={
                    <ProtectedRoute>
                      <DetailedParameters />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/devices/:deviceId/energy-meter/:meterId/chint"
                  element={
                    <ProtectedRoute>
                      <EnergyMeterDetailChint />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/devices/:deviceId/energy-meter/:meterId"
                  element={
                    <ProtectedRoute>
                      <EnergyMeterDetail />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/alarms"
                  element={
                    <ProtectedRoute>
                      <Alarms />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/kosova"
                  element={
                    <ProtectedRoute>
                      <Kosova />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/reports"
                  element={
                    <ProtectedRoute>
                      <Reports />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/dashboard/pv-fleet"
                  element={
                    <ProtectedRoute>
                      <PvFleetEnergyDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <ProtectedRoute>
                      <SystemSettingsPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/me"
                  element={
                    <ProtectedRoute>
                      <MePage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/connections"
                  element={
                    <ProtectedRoute>
                      <ConnectionsPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/about"
                  element={
                    <ProtectedRoute>
                      <AboutPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/"
                  element={<Navigate to="/dashboard" replace />}
                />
              </Routes>
            </GaugeSimulationProvider>
          </BrowserRouter>
        </ConfirmProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
